<template>
  <div 
    v-if="$_productHasTagNews() || typeof $_iconsTags() !== 'undefined'"
    :class="{'single-product-list__has-tags--reverse' : $_productHasTagNews()}"
    class="single-product-list__has-tags">
    <strong
      v-if="$_productHasTagNews()"
      class="single-product-list__has-tags__news">
        {{ $t('common.isNew') }}
    </strong>
    <ol
      v-if="typeof $_iconsTags() !== 'undefined'"
      class="single-product-list__has-tags__icons">
      <li
        v-for="(iconTag, index) of $_iconsTags()"
        :key="index">
          <img
            :src="iconTag.fields.tagIcon.fields.file.url"
            :alt="iconTag.fields.title"
            :width="iconTag.fields.tagIcon.fields.file.details.image.width"
            :height="iconTag.fields.tagIcon.fields.file.details.image.height">
          <strong>{{ iconTag.fields.title }}</strong>
      </li>
    </ol>
  </div>
</template>

<script>

export default {
  name: 'SingleProductListHasTags',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    $_productHasTagNews () {
      if (typeof this.product.fields.tags === 'undefined') return false
      return this.product.fields.tags.some(tag => tag.sys.id === '13RpBAab2koSygiyMGUEUE')
    },
    $_iconsTags () {
      if (typeof this.product.fields.tags === 'undefined') return false
      const iconsTagsArray = this.product.fields.tags.filter(tag => typeof tag.fields.tagIcon !== 'undefined')
      if (iconsTagsArray.length === 0) return undefined
      return iconsTagsArray.sort((a, b) => a - b)
    }
  }
}
</script>

<style lang="scss">
  @import "./singleProductListHasTags.scss";
</style>
